import { render, staticRenderFns } from "./NewFlagModal.vue?vue&type=template&id=fcbb638c&scoped=true&"
import script from "./NewFlagModal.vue?vue&type=script&lang=ts&"
export * from "./NewFlagModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewFlagModal.vue?vue&type=style&index=0&id=fcbb638c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbb638c",
  null
  
)

export default component.exports